module.exports = "/images/vendor/flag-icon-css/flags/4x3/tc.svg?d40761f21eebb19082ad74bd401555ee";